import {
  AuthenticationState,
  AuthenticationUpdateType,
} from '~/types/AuthenticationTypes'

export enum AuthenticationEmitterEventType {
  USER_AUTH_DATA_CLEARED = 'USER_AUTH_DATA_CLEARED',
  USER_AUTH_DATA_UPDATED = 'USER_AUTH_DATA_UPDATED',
  USER_LOGGED_OUT = 'USER_LOGGED_OUT',
  USER_LOGGED_IN = 'USER_LOGGED_IN',
  USER_SESSION_DEPENDENCIES_SET = 'USER_SESSION_DEPENDENCIES_SET',
}

export interface AuthenticationUpdatePayload {
  newAuthState: AuthenticationState
  updateType: AuthenticationUpdateType
}

export type AuthenticationEmitterPayloadMap = {
  [AuthenticationEmitterEventType.USER_AUTH_DATA_CLEARED]: unknown
  [AuthenticationEmitterEventType.USER_AUTH_DATA_UPDATED]: AuthenticationUpdatePayload
  [AuthenticationEmitterEventType.USER_LOGGED_OUT]: unknown
  [AuthenticationEmitterEventType.USER_LOGGED_IN]: unknown
  [AuthenticationEmitterEventType.USER_SESSION_DEPENDENCIES_SET]: unknown
}
